import { render, staticRenderFns } from "./BookingReminders.vue?vue&type=template&id=db71ed86"
import script from "./BookingReminders.vue?vue&type=script&lang=js"
export * from "./BookingReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports